import { HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http';
import { Injectable } from '@angular/core';

import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class AuthInterceptor implements HttpInterceptor {
  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    if (!req.url.includes('/auth/token?') && !req.url.includes('/auth/forgot') && !req.url.includes('/invite/confirm')) {
      const headers: Record<string, string> = {
        Accept: 'application/json, text/plain, */*',
        Authorization: `Bearer ${localStorage.getItem('auth_token')}`
      };

      const companyName = localStorage.getItem('makersite_company_name');
      if (companyName) {
        headers['Makersite-Company-Name'] = companyName;
      }

      req = req.clone({
        // withCredentials: true,
        setHeaders: headers
      });
    }

    return next.handle(req);
  }
}
